import React, { useRef, useEffect, useState } from 'react';
import Canvas2D from './canvas/Canvas2D';
import CalibrationOverlay from './canvas/CalibrationOverlay';
import { useEditorStore } from '../store/useEditorStore';
import { Point2D } from '../types';

const Canvas: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState({ width: 800, height: 600 });
  const [zoom, setZoom] = useState(1);
  const [offset, setOffset] = useState<Point2D>({ x: 0, y: 0 });
  // 监听 project.id 和 projectLoadVersion 来确保项目切换时强制重新挂载
  // 注意：不使用 updatedAt，因为每次元素修改都会更新 updatedAt
  const projectId = useEditorStore((state) => state.project?.id);
  const projectLoadVersion = useEditorStore((state) => state.projectLoadVersion);
  useEditorStore((state) => state.isMeasuring); // Keep for potential future use

  // 用于强制重新挂载 Canvas2D 的 key
  // 使用 projectLoadVersion 确保只在项目切换时重新挂载，不在元素修改时重新挂载
  const canvasKey = `${projectId}-v${projectLoadVersion || 0}`;

  // 防止 offset 不必要的更新导致无限循环
  const handleOffsetChange = (newOffset: Point2D) => {
    setOffset((prev) => {
      if (prev.x === newOffset.x && prev.y === newOffset.y) {
        return prev; // 值没变，返回相同引用避免重渲染
      }
      return newOffset;
    });
  };

  // 监听容器大小变化
  useEffect(() => {
    if (!containerRef.current) return;

    const updateDimensions = () => {
      if (containerRef.current) {
        setDimensions({
          width: containerRef.current.clientWidth,
          height: containerRef.current.clientHeight,
        });
      }
    };

    updateDimensions();

    const resizeObserver = new ResizeObserver(updateDimensions);
    resizeObserver.observe(containerRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="flex-1 bg-gray-100 relative overflow-hidden">
      {/* 全屏2D画布 - 在CAD底图上描绘 */}
      <Canvas2D 
        key={canvasKey}
        width={dimensions.width} 
        height={dimensions.height}
        onZoomChange={setZoom}
        onOffsetChange={handleOffsetChange}
      />
      
      {/* 校准覆盖层 */}
      <CalibrationOverlay 
        width={dimensions.width} 
        height={dimensions.height}
        zoom={zoom}
        offset={offset}
      />
    </div>
  );
};

export default Canvas;
